function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.8 6.4v.2c0 .77-.63 1.4-1.4 1.4h-7C5.63 8 5 7.37 5 6.6v-.2C5 5.63 5.63 5 6.4 5h7c.77 0 1.4.63 1.4 1.4zM19 12c0 .77-.63 1.4-1.4 1.4H6.4c-.77 0-1.4-.63-1.4-1.4 0-.77.63-1.4 1.4-1.4h11.2c.77 0 1.4.63 1.4 1.4zm-8 5.6c0 .77-.63 1.4-1.4 1.4H6.4c-.77 0-1.4-.63-1.4-1.4 0-.77.63-1.4 1.4-1.4h3.2c.77 0 1.4.63 1.4 1.4z"
}));